import { Injectable, Injector } from '@angular/core'
import { TokenService, BaseLogActionService, LogActionDescription } from 'sbs-common'
import { ActionVerb, AddLogActionGQL, TargetTypes } from '../../../../generated/graphql'

@Injectable({
  providedIn: 'root',
})
export class LogActionService extends BaseLogActionService {
  constructor(addLogActionGQL: AddLogActionGQL, tokenService: TokenService, injector: Injector) {
    super(addLogActionGQL, tokenService, injector)
  }

  logNavigation(targetType: TargetTypes, targetId: string, logActionDescription: LogActionDescription): void {
    this.add(ActionVerb.Navigate, targetType, targetId, logActionDescription)
  }

  logQrCode(targetType: TargetTypes, targetId: string, logActionDescription: LogActionDescription): void {
    this.add(ActionVerb.QrCode, targetType, targetId, logActionDescription)
  }

  logRead(targetType: TargetTypes, targetId: string, logActionDescription: LogActionDescription): void {
    this.add(ActionVerb.Read, targetType, targetId, logActionDescription)
  }

  logChange(targetType: TargetTypes, targetId: string, logActionDescription: LogActionDescription): void {
    this.add(ActionVerb.Change, targetType, targetId, logActionDescription)
  }
}
